import React, { FC, ReactElement, useContext } from 'react';
import { useInView } from 'react-intersection-observer';
import GridContext from '../GridContext';
import GridRoot from '../GridRoot';
import { GridElementProps } from './types';

const GridElement: FC<GridElementProps> = (
  props: GridElementProps
): ReactElement => {
  const { lazy = false, sizes, spacing = 0.5, children, theme } = props;

  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '250px',
  });
  const shouldRender = !lazy || inView;

  const { size, numberOfColumns } = useContext(GridContext);

  const root = (
    <GridRoot
      ref={ref}
      columnSize={sizes[size]}
      numberOfColumns={numberOfColumns}
      spacing={spacing}
      theme={theme}
    >
      {shouldRender ? children : null}
    </GridRoot>
  );

  return root;
};

export default GridElement;
